<div class="shape-container {{ externalClass }}">
  <ng-container
    *ngIf="
      keyword === PRODUCT_TYPE_SHAPES.TWO_LEVEL_ROUND ||
        keyword === PRODUCT_TYPE_SHAPES.THR_LEVEL_ROUND ||
        keyword === PRODUCT_TYPE_SHAPES.FOR_LEVEL_ROUND;
        else simpleShape
    "
  >
    <span class="size-shape size-shape-level"></span>
    <span class="size-shape size-shape-level TWO-LEVEL-ROUND"></span>
    <span
      *ngIf="keyword === PRODUCT_TYPE_SHAPES.THR_LEVEL_ROUND || keyword === PRODUCT_TYPE_SHAPES.FOR_LEVEL_ROUND"
      class="size-shape size-shape-level THR-LEVEL-ROUND"
    ></span>
    <span class="size-shape size-shape-level FOR-LEVEL-ROUND" *ngIf="keyword === PRODUCT_TYPE_SHAPES.FOR_LEVEL_ROUND"></span>
  </ng-container>
  <ng-template #simpleShape>
    <span class="size-shape {{ keyword }}"></span>
  </ng-template>
</div>
